<div style="width:500px;">
  <div style="width:99%;">
    <span> <button class="btn btn border" (click)="saveSignType()" [disabled]="!form.dirty">Spara</button> <button class="btn btn border" style="margin-left:20px;" (click)="cancel()">Avbryt</button></span>
    <br>
    <hr />
    <form [formGroup]="form">
      <div class="row">
        <div class="col-md-4">
          <label>
            Namn
          </label>
          <input id="name" type="text" class="form-control form-control-sm" formControlName="name">
        </div>
        <div class="col-md-2">
          <label>
            Sorteringsordning
          </label>
          <input id="sort" type="text" class="form-control form-control-sm" formControlName="sort">
        </div>
      </div>
    </form>
  </div>
</div>